<div class="create-property">
  <form [formGroup]="propertyForm" (ngSubmit)="saveProperty()">

    <div class="col-12 d-flex align-items-center">
      <div class="form-group mb-2 col-6">
        <label for="name">Property Name</label>
        <input pInputText class="w-100" id="name" formControlName="name" type="text" />
      </div>

      <!-- <div class="col-6 p-1">
        <label for="user_id">User</label>
        <p-dropdown styleClass="w-100" [options]="users" optionLabel="first_name" formControlName="user_id"
          optionValue="_id" placeholder="Select a user" [showClear]="true"></p-dropdown>
      </div> -->
    </div>

    <div class="col-12 d-flex align-items-center">
      <div class="form-group mb-2 col-6">
        <label for="latitude">Latitude</label>
        <input pInputText class="w-100" id="latitude" formControlName="latitude" type="number" />
      </div>

      <div class="form-group mb-2 col-6">
        <label for="longitude">Longitude</label>
        <input pInputText class="w-100" id="longitude" formControlName="longitude" type="number" />
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="address">Address</label>
      <input pInputText class="w-100" id="address" formControlName="address" type="text" />
    </div>

    <div class="form-group mb-2">
      <label for="description">Description</label>
      <textarea pTextarea class="w-100" id="description" formControlName="description"></textarea>
    </div>
    <div class="col-12 d-flex align-items-center">
      <div class="col-12 p-1">
        <label for="yardi_property_id">Map Yardi Property</label>
        <p-dropdown styleClass="w-100" [options]="yardiProperties" optionLabel="name" optionValue="_id"
          formControlName="yardi_property_id" placeholder="Select a Yardi Property" [showClear]="true"></p-dropdown>
      </div>
    </div>
    <!-- <div class="col-12 d-flex align-items-center">
      <div class="col-12 p-1">
        <label for="property_category_id">Property Category</label>
        <p-dropdown styleClass="w-100" [options]="categories" optionLabel="name" optionValue="_id"
          formControlName="property_category_id" placeholder="Select a category" [showClear]="true"></p-dropdown>
      </div>
    </div> -->
    <!-- <div class="col-12 d-flex align-items-center">
      <div class="col-12 p-1">
        <label for="amenities_id">Amenities</label>
        <p-multiSelect styleClass="w-100" optionLabel="name" [options]="amenities" formControlName="amenities_id"
          placeholder="Select amenities" [showClear]="true" display="chip">
        </p-multiSelect>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center">
      <div class="col-6 p-1">
        <label for="country_id">Country</label>
        <p-dropdown styleClass="w-100" [options]="countries" optionLabel="name" optionValue="_id"
          formControlName="country_id" placeholder="Select a country" [showClear]="true"
          (onChange)="onCountryChange($event)"></p-dropdown>
      </div>

      <div class="col-6 p-1">
        <label for="state_id">State</label>
        <p-dropdown styleClass="w-100" [options]="states" optionLabel="name" optionValue="_id"
          formControlName="state_id" placeholder="Select a state" (onChange)="onStateChange($event)" [disabled]="true"
          [showClear]="true"></p-dropdown>
      </div>
    </div>

    <div class="d-flex flex-column">
      <label for="city_id">City</label>
      <p-dropdown styleClass="w-100" [options]="cities" optionLabel="name" optionValue="_id" formControlName="city_id"
        placeholder="Select a city" [showClear]="true"></p-dropdown>
    </div>

    <div class="col-12 d-flex align-items-center">
      <div class="form-group col-6 p-1">
        <label for="property_min_price">Min Price</label>
        <input pInputText class="w-100" id="property_min_price" formControlName="property_min_price" type="number" />
      </div>

      <div class="form-group col-6 p-1">
        <label for="property_max_price">Max Price</label>
        <input pInputText class="w-100" id="property_max_price" formControlName="property_max_price" type="number" />
      </div>
    </div>

    <div class="col-12 d-flex align-items-center">
      <div class="form-group  col-6 p-1">
        <label for="property_min_deposit">Min Deposit</label>
        <input pInputText class="w-100" id="property_min_deposit" formControlName="property_min_deposit"
          type="number" />
      </div>

      <div class="form-group  col-6 p-1">
        <label for="property_max_deposit">Max Deposit</label>
        <input pInputText class="w-100" id="property_max_deposit" formControlName="property_max_deposit"
          type="number" />
      </div>
    </div>

    <div class="form-group mb-2">
      <label for="property_units">Units</label>
      <input pInputText class="w-100" id="property_units" formControlName="property_units" type="text" />
    </div> -->
    <div class="btn-container">
      <p-button type="submit" [disabled]="propertyForm.invalid">{{buttonLabel}} Property</p-button>
    </div>
  </form>
</div>